import { Link } from 'react-router-dom';
import { MapPin, Calendar, Tag, Maximize2, ArrowUpRight } from 'lucide-react';

const ProjectBadges = ({ project, featured }) => (
  <>
    {!featured && <div className="absolute top-5 left-5 px-3 py-1.5 rounded-full bg-black/40 backdrop-blur-md border border-white/10"><span className="flex items-center gap-1.5 text-[10.5px] tracking-[0.2em] text-white/85 uppercase font-medium"><Tag size={11} className="text-accent" />{project.category}</span></div>}
    <div data-testid={`${featured ? 'featured-project' : 'project'}-area-${project.slug}`} className={`absolute top-5 ${featured ? 'left-5' : 'right-5'} px-3 py-1.5 rounded-full bg-clay text-background text-[10.5px] font-bold flex items-center gap-1`}>
      <Maximize2 size={11} strokeWidth={2.5} />{project.areaM2.toLocaleString('tr-TR')}{featured && ' m²'}
    </div>
    {!featured && <div className="absolute bottom-5 right-5 w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center opacity-0 -translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500"><ArrowUpRight size={16} /></div>}
  </>
);

const ProjectCaption = ({ project, featured }) => (
  <div className={`absolute bottom-0 left-0 right-0 ${featured ? 'p-7' : 'p-6'}`}>
    <div className="flex flex-wrap items-center gap-4 mb-3 text-[10.5px] tracking-[0.2em] uppercase">
      <span className="flex items-center gap-1.5 text-accent font-medium"><MapPin size={11} />{project.location}</span>
      {!featured && <span className="flex items-center gap-1.5 text-white/60"><Calendar size={11} />{project.year}</span>}
    </div>
    <h3 className={`${featured ? 'text-[22px]' : 'text-[19px]'} font-semibold text-white leading-tight`}>{project.title}</h3>
    <div className="mt-4 h-[2px] w-8 bg-primary group-hover:w-20 transition-[width] duration-500" />
  </div>
);

export const ProjectCard = ({ project, featured = false }) => (
  <Link
    data-testid={`${featured ? 'featured-project' : 'project-card'}-${project.slug}`}
    to={`/projeler/${project.slug}`}
    className={`group relative overflow-hidden rounded-2xl block text-left ${featured
      ? 'shrink-0 w-[min(300px,calc(100vw-3rem))] sm:w-[340px] lg:w-[360px] h-[460px] lg:h-[500px] snap-start'
      : 'bg-card border border-border hover:border-primary/60 transition-all duration-500 h-full hover:-translate-y-1 hover:shadow-xl hover:shadow-primary/10'}`}
  >
    <div className={`relative overflow-hidden ${featured ? 'h-full' : 'aspect-[4/5]'}`}>
      <img src={project.image} alt={project.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/25 to-transparent" />
      <ProjectBadges project={project} featured={featured} />
      <ProjectCaption project={project} featured={featured} />
    </div>
  </Link>
);